namespace Matrix.Rebalancer {
    export interface SummaryViewRow {
        ViewCode?: string;
        Name?: string;
        ModelTypeCode?: string;
        OwnershipBasisCode?: string;
        RowId?: number;
        Version?: number;
        CreatedBy?: string;
        CreatedWhen?: string;
        UpdatedBy?: string;
        UpdatedWhen?: string;
        ModelTypeName?: string;
        ModelTypeRowId?: number;
        ModelTypeLevels?: number;
        OwnershipBasisName?: string;
        OwnershipBasisRowId?: number;
    }

    export namespace SummaryViewRow {
        export const idProperty = 'ViewCode';
        export const nameProperty = 'Name';
        export const localTextPrefix = 'Rebalancer.SummaryView';
        export const deletePermission = 'DataAdmin:Rebalancer';
        export const insertPermission = 'DataAdmin:Rebalancer';
        export const readPermission = 'Read:Rebalancer';
        export const updatePermission = 'DataAdmin:Rebalancer';

        export declare const enum Fields {
            ViewCode = "ViewCode",
            Name = "Name",
            ModelTypeCode = "ModelTypeCode",
            OwnershipBasisCode = "OwnershipBasisCode",
            RowId = "RowId",
            Version = "Version",
            CreatedBy = "CreatedBy",
            CreatedWhen = "CreatedWhen",
            UpdatedBy = "UpdatedBy",
            UpdatedWhen = "UpdatedWhen",
            ModelTypeName = "ModelTypeName",
            ModelTypeRowId = "ModelTypeRowId",
            ModelTypeLevels = "ModelTypeLevels",
            OwnershipBasisName = "OwnershipBasisName",
            OwnershipBasisRowId = "OwnershipBasisRowId"
        }
    }
}
